import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AuthService } from '../../auth.service';
import { ForgotPasswordViewModel } from '../../auth-models';

@Component({
  selector: 'app-ivrs-forgot-password',
  templateUrl: './ivrs-forgot-password.component.html',
  styleUrls: ['./ivrs-forgot-password.component.scss'],
  standalone: false,
})
export class IvrsForgotPasswordComponent implements OnInit {
  pageTitle = 'IVRS Forgot Password';
  isBusy: boolean;
  requestCompleted: boolean;

  formGroup: UntypedFormGroup;

  get email() {
    return this.formGroup.get('email');
  }

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.formGroup = new UntypedFormGroup({
      email: new UntypedFormControl('', { validators: [Validators.required, Validators.email] }),
    });
  }

  getErrorMessage() {
    return this.email.hasError('required') ? 'You must enter a value' : this.email.hasError('email') ? 'Not a valid email' : '';
  }

  onSubmit() {
    if (this.formGroup.valid) {
      const model = this.formGroup.value as ForgotPasswordViewModel;

      this.authService.ivrsForgotPassword(model).subscribe(
        (response) => {
          this.requestCompleted = true;
        },
        (error) => {
          this.notificationService.error(error?.error);
        }
      );
    }
  }
}
